module.exports = __webpack_public_path__ + "img/32.4a339680.png";